{
  "name": "client-app",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.0.2",
    "@angular/common": "^22.0.2",
    "@angular/compiler": "^22.0.2",
    "@angular/core": "^22.0.2",
    "@angular/forms": "^22.0.2",
    "@angular/material": "^22.0.2",
    "@angular/material-moment-adapter": "^22.0.2",
    "@angular/platform-browser": "^22.0.2",
    "@angular/platform-browser-dynamic": "^22.0.2",
    "@angular/router": "^22.0.2",
    "@ngx-translate/core": "^15.0.0",
    "bootstrap": "^5.3.8",
    "moment": "^2.29.4",
    "ng2-pdf-viewer": "^10.0.0",
    "raygun4js": "^2.25.6",
    "rxjs": "~7.5.0",
    "save": "^2.9.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.0.3",
    "@angular/cli": "~22.0.3",
    "@angular/compiler-cli": "^22.0.2",
    "@types/jasmine": "~4.0.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "6.0.3"
  },
  "prettier": {
    "singleQuote": true,
    "trailingComma": "none"
  }
}
